export const setPrice = async (context, price) => {
  context.commit('SET_PRICE', price)
}
